{
  "title": "Retirer le bénévole",
  "confirm": "Retirer {{person}} de l'équipe {{team}} ?",
  "confirmUnnamed": "Retirer ce bénévole de cette équipe ?",
  "caption": "Cette personne ne sera pas supprimée de la liste des personnes de votre église. Vous pourrez l'inviter à nouveau dans cette équipe à tout moment.",
  "remove": "Retirer de l'équipe",
  "removing": "Retrait…"
}
